export default {
    BusinessThirdOrderAdd: {
        Basic: '三方订单基本信息',
        Third: '客户订单号',
        Ordertype: '订单类型',
        Selectchannel: '选择渠道',
        Selectstore: '选择店铺',
        Selectsales: '选择销售员工',
        Pleaseselect: '请选择',
        Pleasestore: '请先选择销售店铺',
        picking: '选择提货店铺',
        Tripartite: '三方订单下单时间',
        Freight: '运费',
        Merchant: '商家备注',
        Buyer: '买家以及收货信息',
        Delivery: '提货方式',
        nickname: '买家昵称',
        Consignee: '收货人姓名',
        mobile: '买家手机号',
        phone: '收货人手机号',
        Shipping: '收货地址',
        Detailed: '详细地址',
        comments: '买家备注',
        Payment: '支付信息',
        method: '支付方式',
        document: '支付单号',
        amount: '支付金额',
        status: '支付状态',
        time: '支付时间',
        information: '商品信息',
        Add: '添加商品',
        Freights: '运费',
        Totalgoods: '商品总金额',
        Totalamount: '优惠总金额',
        Totalreceivable: '订单应收总金额',
        Totalactually: '买家实付总金额',
        common: '添加普通商品',
        package: '添加组合商品',
        province: '请选择省/市/区',
        detailedaddress: '请输入详细地址',
        channel: '请选择渠道',
        store: '请选择店铺',
        order: '请输入客户订单号',
        ordering: '请选择三方订单下单时间',
        type: '请选择订单类型',
        thenickname: '请输入买家昵称',
        thename: '请输入收货人姓名',
        your: '请输入手机号',
        Pleasemethod: '请选择支付方式',
        Pleaseamount: '请输入支付金额',
        Pleasepayment: '请选择支付状态',
        selecttime: '请选择支付时间',
        pickupstore: '请选择提货店铺',
        amethod: '请选择提货方式',
        sure: '确定删除?',
        Deletion: '删除成功',
        cannot: '支付时间不能小于下单时间',
        sales: '三方平台销售总价需要与支付金额相等！',
        Submitted: '提交成功',
        deliveryAppointmentTime: '送货预约时间',
        physicalWarehouseNotFound: '未找到实仓，请检查仓库配置',
        form: {
            // Product: '商品名称',
            // code: '商品编码',
            SKU: 'SKU编码',
            Quantity: '数量',
            Giveaway: '是否赠品',
            Unit: '商品单价',
            Total: '商品总金额',
            Merchant: '商家承担优惠金额',
            The: '三方承担优惠金额',
            Operation: '操作',
        }
    }
};
